import { useStiggTheme } from '@stigg-theme';
import { Text, GridFlex, Icon, Button, useSupportChat } from '@stigg-components';
import { t } from 'i18next';

const getImageUrl = (theme: string) => `/assets/workflows/workflowsEmptyState.${theme}.svg`;

export function WorkflowsRequestAccess() {
  const { theme } = useStiggTheme();
  const { showNewMessage } = useSupportChat();

  const handleLearnMoreClick = () => {
    window.open(t('workflows.requestAccessPage.docsLinkUrl'), '_blank');
  };

  return (
    <GridFlex.ColumnMiddle container $fullHeight>
      <GridFlex.RowMiddle container gap={11} flexWrap="nowrap">
        <GridFlex.Column item maxWidth={350} gap={4}>
          <Icon type="custom" icon="Workflow" color="default" size={32} overrideFill />
          <Text.B1 $bold color="primary">
            {t('workflows.requestAccessPage.title')}
          </Text.B1>
          <Text.B2 color="secondary" style={{ wordBreak: 'break-word' }}>
            {t('workflows.requestAccessPage.subtitle')}
          </Text.B2>
          <GridFlex.RowCenter gap={2}>
            <Button
              variant="contained"
              onClick={() => showNewMessage(t('workflows.requestAccessPage.requestAccessSupportChatMessage'))}>
              {t('workflows.requestAccessPage.requestAccessButton')}
            </Button>
            <Button variant="text" onClick={handleLearnMoreClick}>
              {t('sharedComponents.learnMore')}
            </Button>
          </GridFlex.RowCenter>
        </GridFlex.Column>
        <GridFlex.ColumnMiddle item>
          <img src={getImageUrl(theme.isLightTheme ? 'light' : 'dark')} alt="workflows-request-access" />
        </GridFlex.ColumnMiddle>
      </GridFlex.RowMiddle>
    </GridFlex.ColumnMiddle>
  );
}
